import { render, staticRenderFns } from "./examPrint.vue?vue&type=template&id=1f90843a&scoped=true&"
import script from "./examPrint.vue?vue&type=script&lang=js&"
export * from "./examPrint.vue?vue&type=script&lang=js&"
import style0 from "./examPrint.vue?vue&type=style&index=0&id=1f90843a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90843a",
  null
  
)

export default component.exports